{
  "": "",
  "actions": {
    "update": "Aktualisieren",
    "updated": "Aktualisiert"
  },
  "buttons": {
    "accept": "Bestätigen",
    "addEmail": "Email hinzufügen",
    "addMultipleItems": "Mehrere Einträge hinzufügen",
    "assignTicket": "Ticket zuweisen",
    "assignTicketOfName": "Ticket {name} zuweisen",
    "attach": "Anhängen",
    "cancel": "Abbrechen",
    "checklistContinueAnyway": "Nicht alles gelöst: Trotzdem fortfahren",
    "checklistUndoContinue": "Offene Aufgaben lösen",
    "connect": "Verknüpfen",
    "delete": "Löschen",
    "downloadFile": "Datei herunterladen",
    "downloadFileWithName": "Datei \"{name}\" herunterladen",
    "enterNegotiationMode": "Verhandlungsmodus",
    "exitNegotiationMode": "Kostenpositionen",
    "export": "Exportieren",
    "exportCSV": "Exportieren als CSV",
    "hide": "Verbergen",
    "large": "Groß",
    "load": "Laden",
    "lockUnlocked": "Bereit - sperren",
    "makeReadyToSign": "Benachrichtige Unterzeichner",
    "newTicket": "Neues Ticket",
    "nextProcessStep": "Zum nächsten Schritt",
    "nextStep": "Zum Schritt \"{stepName}\"",
    "no": "Nein",
    "normal": "Normal",
    "reject": "Abbrechen",
    "revert": "Zurücksetzen",
    "save": "Speichern",
    "saveAndCreateNext": "Speichern und nächsten erstellen",
    "selectAttachments": "Anhänge",
    "selectUnrelatedAttachments": "Unabhängige Anhänge auswählen",
    "send": "Senden",
    "show": "Anzeigen",
    "showLess": "Weniger anzeigen",
    "showMore": "Mehr anzeigen",
    "small": "Klein",
    "uiPluginContinueAnyway": "Nicht alles gelöst: Trotzdem fortfahren",
    "uiPluginUndoContinue": "Offene Aufgaben lösen",
    "unlockLocked": "Nicht bereit - trotzdem freischalten",
    "update": "Aktualisieren",
    "yes": "Ja"
  },
  "confirm": {
    "default": {
      "header": "Bestätigen",
      "message": "Möchten Sie fortfahren?"
    },
    "delete": {
      "header": "Eintrag löschen",
      "message": "Möchten Sie diesen Eintrag tatsächlich löschen?"
    },
    "deleteTicketRelation": {
      "header": "Eintrag mit Ticket-Beziehung löschen",
      "message": "Möchten Sie diesen Eintrag tatsächlich löschen? Er hat eine Beziehung zu einem Ticket, das ebenfalls gelöscht wird."
    },
    "nextStep": {
      "header": "Haben Sie diesen Teil der Aufgabe abgeschlossen?",
      "message": "Sie können diesen Schritt nachträglich nicht mehr rückgängig machen."
    },
    "save": {
      "header": "Eintrag speichern",
      "message": "Möchten Sie diesen Eintrag tatsächlich löschen?"
    }
  },
  "enums": {
    "AC_BLUEPRINT": "Blaupause",
    "AC_BLUEPRINT_MULTIPLE": "Blaupause (mehrere Instanzen)",
    "AC_CHECKLIST": "Checkliste",
    "AC_CONTRACTS": "Verträge",
    "AC_COSTSTATEMENTINVOICE": "Nebenkostenabrechnung",
    "AC_DOCUMENTUPLOAD": "Uploadmodul",
    "AC_EMAIL": "Email",
    "AC_LOCATIONLIST": "Standortliste",
    "AC_NONE": "Keine verknüpfte Komponente",
    "AC_SKETCH": "Sketch-Komponente",
    "AC_STAMPING": "Prüfstempel",
    "AC_UPLOAD": "Dokumentenupload",
    "AC_YOUSIGN": "YouSign",
    "ACTIVE": "Option",
    "AD_SPACE": "Werbefläche",
    "ADDITIONALCOSTADVANCEPAYMENT": "Vorauszahlung Nebenkosten",
    "ADDITIONALCOSTFLATRATE": "Nebenkostenpauschale",
    "ADDITIONALCOSTFLATRATEEURO": "Nebenkostenpauschale Euro",
    "ADDITIONALCOSTFLATRATEPERCENTAGE": "Nebenkostenpauschale Prozent",
    "ADMINISTRATIVECOSTS": "Pauschale Verwaltungskosten",
    "ADMINISTRATIVENOTICE": "Behördenbescheid",
    "ADVERTISING": "Werbevertrag",
    "ADVERTISINGASSOCIATION": "Werbegemeinschaft",
    "ADVERTISINGCOSTS": "Werbebeitrag",
    "ANCILLARY_AREA": "Nebenfläche",
    "AREA": "Fläche",
    "ASSIGN_TEAM": "Team zuweisen",
    "AUTOMATIC": "Option automatisch",
    "AUTOMATIC_EXTENSION": "Automatische Verlängerung",
    "AVAILABLE": "Verfügbar",
    "BASERENT": "Grundmiete",
    "CENTER_MANAGEMENT": "Centermanagement",
    "CENTERMANAGEMENT": "Pauschale Centermanagement",
    "CLARIFIED": "Geklärt",
    "CLEAR": "Klar",
    "CLOSED": "beendet",
    "COMMERCIALBUILDING": "Geschäftshaus",
    "COMMERCIALCENTRE": "Einkaufszentrum",
    "COMPLETED": "Beendet",
    "CONCESSION_AREA": "Konzessionsfläche",
    "CREDITOR_PAYEE_": "Kreditor (Zahlungsempfänger)",
    "DAY": "Tag | Tage",
    "DAY_S": "{count} Tag | {count} Tage",
    "DE": "Deutsch",
    "DEADLINE_COUNTDOWN": "Noch {count} Arbeitstag | Noch {count} Arbeitstage",
    "DEADLINE_OVERDUE": "Frist läuft ab: {date}",
    "DEADLINE_OVERDUE_WARN": "Überfällig! Fristende: {date}",
    "DEADLINE_TRIGGER": "Deadline-Trigger",
    "DISCOUNT_PERCENTAGE": "Nachlass",
    "DR_": "Dr",
    "EN": "Englisch",
    "ENGLISH": "Englisch",
    "FACILITYMANAGER": "Facility Manager",
    "FMCONTACTDATA": "FM-Kontaktdaten",
    "FMCONTRACT": "FM-Vertrag",
    "FMDUNNINGNOTICE": "FM-Mahnung",
    "FMINCIDENTREPORT": "FM-Störmeldung",
    "FMINSPECTIONREPORT": "FM-Prüfprotokolle",
    "FMINVOICE": "FM-Rechnung",
    "FMMISCCORRESPONDENCE": "FM-Sonstiger Schriftverkehr",
    "FMOFFER": "FM-Angebot",
    "FMPHOTOS": "FM-Fotos",
    "FMPLANS": "FM-Pläne (Grundriss, Einrichtung)",
    "FR": "Französisch",
    "FRAMEWORKAGREEMENTS": "Rahmenvertrag",
    "FRENCH": "Französisch",
    "GASTRONOMY": "Gastronomie",
    "GERMAN": "Deutsch",
    "GROUNDRENT": "Erbbauzins",
    "HEATINGCOSTADVANCE_PAYMENT": "Vorauszahlung Heizkosten",
    "HEATINGCOSTADVANCEPAYMENT": "Vorauszahlung Heizkosten",
    "HIGH": "Hoch",
    "HU": "Ungarisch",
    "HUNGARIAN": "Ungarisch",
    "IN_CLARIFICATION": "In Klärung",
    "IN_FOCUS": "im Fokus",
    "IN_PROGRESS": "in Arbeit",
    "IN_PROGRESS_OVERDUE": "in Arbeit (überfällig)",
    "IN_PROGRESS_OVERDUE_WARN": "weit überfällig",
    "IN_TIME": "in Zeit",
    "INCLARIFICATION": "In Klärung",
    "INSPECTION": "Inspektion",
    "IS_ACTIVE": "Aktiv",
    "LANDLORD": "Vermieter",
    "LANDLORD_MANAGER": "Verwalter Vermieter",
    "LEASE": "Leasing",
    "LEASE_CONTRACT": "Mietvertrag",
    "LEASEADDITIONALAGREEMENTS": "Zusatzvereinbarungen",
    "LEASEAGREEMENT": "Mietvertrag",
    "LEASECONTACTDATA": "Kontaktdaten",
    "LEASECONTRACTMISCCORRESPONDENCE": "MVM - Sonstiger Schriftverkehr",
    "LEASEHANDOVERREPORT": "Übergabeprotokolle",
    "LEASEHOLD": "Erbbaurecht",
    "LEASEOPTIONOREXTENSIONLETTER": "Optionsausübung / Verlängerungsschreiben",
    "LEASEOWNERORCONTACTCHANGE": "Wechsel Eigentümer, Verwalter oder Ansprechpartner",
    "LEASEPREVIOUSAGREEMENT": "Altvertrag",
    "LEASERENTADJUSTMENT": "Mietanpassung",
    "LEASERENTDUNNINGNOTICE": "Mietmahnung",
    "LEASERENTINDEXINVOICE": "Indexrechnung",
    "LEASERENTINDEXLETTER": "Indexschreiben",
    "LEASERENTINVOICE": "Mietrechnung",
    "LEASERETURNHANDOVERREPORT": "Rückgabeprotokolle",
    "LEASESECURITYDEPOSIT": "Mietsicherheit",
    "LEASESPECIALUSEAGREEMENT": "Sondernutzung",
    "LEASESUPPLEMENT": "Nachtrag",
    "LEASETERMINATIONLETTER": "Kündigungsschreiben",
    "LOG_TRIGGER": "Logging-Trigger",
    "LOGISTIC": "Logistik",
    "LOW": "Niedrig",
    "MAIN_AREA": "Hauptfläche",
    "MAINTENANCE": "Wartung",
    "MAINTENANCE_CONTRACT": "Wartungsvertrag",
    "MAINTENANCECONTRACT": "Wartungsvertrag",
    "MEDICALFACILITY": "Ärztliche Einrichtung",
    "MEDIUM": "Mittel",
    "MINIMUMRENT": "Mindestmiete",
    "MISCELLANEOUSCORRESPONDENCE": "Sonstiger Schriftverkehr",
    "MONTH": "Monat | Monate",
    "MONTH_S": "{count} Monat | {count} Monate",
    "MR_": "Herr",
    "MRS_": "Frau",
    "MS_": "Frau",
    "NEW": "neu",
    "NONE": "-",
    "OFFICE_ADMINISTRATION": "Büro/Verwaltung",
    "OFFICEBUILDING": "Bürogebäude",
    "ALL_OPEN": "alle offenen",
    "OPEN": "offen",
    "OPEN_OVERDUE": "fällig",
    "OPEN_OVERDUE_WARN": "überfällig",
    "OPERATINGCOSTCORRECTION": "NK Korrektur",
    "OPERATINGCOSTCREDITNOTE": "NK Gutschrift",
    "OPERATINGCOSTINVOICE": "Nebenkostenabrechnung",
    "OPERATINGCOSTMISCCORRESPONDENCE": "NK-Sonstiger Schriftverkehr",
    "OPERATINGCOSTOBJECTIONLETTER": "NK Widerspruch",
    "OPERATINGCOSTSUPPORTINGDOCUMENTS": "NK Belege",
    "OPERATIONALEQUIPMENTLEASE": "Betriebsvorrichtungsvertrag",
    "OTHER": "Sonstiges",
    "OTHER_APARTMENTS": "Sonstiges/Wohnungen",
    "OTHER_USE": "Sonstige Nutzung",
    "OUTLET": "Outlet",
    "OVERDUE": "fällig",
    "OVERDUE_WARN": "weit überfällig",
    "OWNER": "Vermieter",
    "PARKING_AREA": "Parkfläche",
    "PARKINGSPACE": "Parkplatzvertrag",
    "PARKINGSPACERENTAL": "Stellplatzmiete",
    "PARTLY": "in Arbeit",
    "PERMANENTUSERIGHT": "Dauernutzungsrecht",
    "PRACTICE": "Praxis",
    "PRIORITY_LEVEL": "Priorität",
    "PROCESSED": "klassifiziert",
    "PROF_": "Prof",
    "PROF_DR_": "Prof Dr",
    "PROPERTY_LANDLORD": "Vermieter Immobilie",
    "PROPERTY_MANAGER": "Verwalter",
    "PROPERTY_OWNER": "Eigentümer Immobilie",
    "PROPERTY_TENANT": "Mieter Immobilie",
    "PROPERTYMANAGER": "Verwalter",
    "PURCHASE_AGREEMENT": "Kaufvertrag",
    "REGION": "Region",
    "RENTAL": "Mietvertrag",
    "RETAILCENTER": "Fachmarktzentrum",
    "SALES": "Einzelhandel",
    "SERVICE_AGREEMENT": "Servicevertrag",
    "SERVICE_CONTRACT_TYPE": "Servicevertragstyp",
    "SERVICECONTRACTINTERNETORPHONE": "Internet oder Telefon",
    "SERVICECONTRACTPOSTCLEANINGREQUIRED": "Nachreinigung erforderlich",
    "SERVICEPROVIDER": "Service Provider",
    "SKIP": "Übersprungen",
    "SPECIAL_RESILIATION": "Sonderkündigung",
    "SPECIALUSEPERMIT": "Sondernutzungserlaubnis",
    "SPECIALUSEPERMITWITHBOOKING": "Sondernutzungsbescheide mit Dauerbuchungscharakter",
    "STANDALONE": "Freistehend",
    "START_DATE": "Startdatum",
    "STORAGE": "Lager",
    "STORAGECONTRACT": "Lagervertrag",
    "SUBLEASE": "Untermietvertrag",
    "SUPPLYCONTRACT": "Liefervertrag",
    "TEAM_BO": "Backoffice",
    "TEAM_BUHA": "Buchhaltung",
    "TEAM_BUHA_CUST": "Kunde Buchhaltung",
    "TEAM_FM": "Facility Management",
    "TEAM_FM_CUST": "Kunde Facility Management",
    "TEAM_FOMA": "Forderungsmanagement",
    "TEAM_MVM": "Mietvertragsmanagement",
    "TEAM_MVM_LAW": "Anwalt Mietvertragsmanagement",
    "TEAM_MVM_LAWYER": "Anwalt Mietvertragsmanagement",
    "TEAM_NKA": "Nebenkostenabrechnung",
    "TEAM_NKA_CUST": "Kunde Nebenkostenabrechnung",
    "TEAM_NONE": "Keine Teamzuweisung",
    "TENANT": "Mieter",
    "TENANT_AND_LANDLORD": "Mieter und Vermieter",
    "TENANT_OR_LANDLORD": "Mieter oder Vermieter",
    "TERMINATION": "Kündigung",
    "TICKETSTATUS_ALL_OPEN": "alle offenen",
    "TICKETSTATUS_CLOSED": "geschlossen",
    "TICKETSTATUS_IN_FOCUS": "im Fokus",
    "TICKETSTATUS_IN_PROGRESS": "in Arbeit",
    "TICKETSTATUS_IN_TIME": "in Zeit",
    "TICKETSTATUS_NEW": "neu",
    "TICKETSTATUS_OVERDUE": "fällig",
    "TICKETSTATUS_OVERDUE_WARN": "weit überfällig",
    "TURNOVERBASEDRENT": "Umsatzmiete",
    "TURNOVERBASEDRENTADVANCEPAYMENT": "Vorauszahlung Umsatzmiete",
    "UNAVAILABLE": "Nicht verfügbar",
    "UNCLEAR": "Unklar",
    "CUBICMETER": "Kubikmeter",
    "DEGREEDAYS": "Gradtage",
    "HOURS": "Stunden",
    "KILOGRAM": "Kilogramm",
    "KILOWATTHOURS": "Kilowattstunden",
    "PERCENT": "Prozent",
    "PIECE": "Stück",
    "SQUAREMETER": "Quadratmeter",
    "UNPROCESSED": "unbearbeitet",
    "UTILITY_MANAGER": "Verwalter Nebenkosten",
    "WEEK": "Woche | Wochen",
    "WEEK_S": "{count} Woche | {count} Wochen",
    "WIDGET_EMAIL_CLASSIFIED": "unbearbeitet",
    "WIDGET_EMAIL_NOT_CLASSIFIED": "bearbeitet",
    "WIDGET_STATUS_ALL_OPEN": "alle offenen",
    "WIDGET_STATUS_CLOSED": "geschlossen",
    "WIDGET_STATUS_IN_FOCUS": "im Fokus",
    "WIDGET_STATUS_IN_PROGRESS": "in Arbeit",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE": "fällig",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE_WARN": "überfällig",
    "WIDGET_STATUS_IN_TIME": "in Zeit",
    "WIDGET_STATUS_NEW": "neu",
    "WIDGET_STATUS_OPEN": "offen",
    "WIDGET_STATUS_OPEN_OVERDUE": "fällig, unbearbeitet",
    "WIDGET_STATUS_OPEN_OVERDUE_WARN": "überfällig, unbearbeitet",
    "WIDGET_STATUS_OVERDUE": "fällig",
    "WIDGET_STATUS_OVERDUE_WARN": "überfällig",
    "WIDGET_STATUS_TICKETSTATUS_CLOSED": "beendet",
    "YEAR": "Jahr | Jahre",
    "YEAR_S": "{count} Jahr | {count} Jahre",
    "YOUSIGN_DONE": "signiert",
    "YOUSIGN_ONGOING": "ausstehend"
  },
  "errors": {
    "CANNOT_BE_CREATED": "Element kann nicht erstellt werden",
    "CANNOT_BE_DELETED": "Element kann nicht gelöscht werden",
    "CANNOT_BE_FOUND": "Element kann nicht gefunden werden",
    "CANNOT_BE_UPDATED": "Element kann nicht aktualisiert werden",
    "dateBeforeIssueDate": "Das Datum liegt vor dem Ausstellungsdatum",
    "dateBeforeObjectionDeadline": "Die interne Widerspruchsfrist liegt vor der Widerspruchsfrist",
    "invalidIban": "Dies ist keine valide IBAN",
    "issueDateBeforePeriodEnd": "Das Ausstellungsdatum liegt vor dem Ende des Abrechnungszeitraums",
    "netGreaterThanGross": "Der Nettobetrag kann nicht größer als der Bruttobetrag sein",
    "periodEndBeforeStart": "Das Enddatum liegt vor dem Startdatum",
    "required": "Dieses Feld ist erforderlich",
    "validation": {
      "invalidDateInput": "Kein valides Datum"
    }
  },
  "info": {
    "SUCCESS_CREATE": "Element wurde erfolgreich erstellt",
    "SUCCESS_DELETE": "Element wurde erfolgreich gelöscht",
    "SUCCESS_UPDATE": "Element wurde erfolgreich aktualisiert"
  },
  "labels": {
    "orderDirection": "Sortierrichtung",
    "accountingArea": "Buchhaltungsbereich",
    "actingBy": "Vertreten durch",
    "action": "Aktion",
    "actions": "Aktionen",
    "actionStart": "Aktionbeginn",
    "activate": "Aktivieren",
    "active": "Aktiv",
    "add": "Neuer Eintrag",
    "additionalAddressInfo": "Zusätzliche Adressinformation",
    "addPositionChild": "Neue Unterposition",
    "address": "Adresse",
    "addresses": "Adressen",
    "addressId": "Adress-ID",
    "addressIdShort": "AID",
    "addTrigger": "Neuer Trigger",
    "adjustmentInterval": "Anpassungsintervall",
    "adjustmentPossible": "Anpassung möglich",
    "advancedFilters": "Erweiterte Filter",
    "allComments": "Alle Kommentare",
    "alldocuments": {
      "add": "Upload"
    },
    "allIDs": "IDs Dokumente & Mails",
    "allIDsShort": "IDs",
    "allNamesAndSubjects": "Betreff",
    "allocationSpace": "Zuweisungsfläche",
    "amount": "Betrag",
    "answerIsRequired": "Antwort erforderlich",
    "approvalNr": "Freigabe-Nr.",
    "area": "Bereich",
    "areaCount": "Anzahl der Bereiche",
    "areaDesignation": "Flächenbezeichnung",
    "areaName": "Name",
    "areaNameExternal": "Externer Bereichsname",
    "areas": "Bereiche",
    "areaSize": "Flächengröße",
    "areasToContracts": "Bereiche",
    "areaToPointOfSale": "Point of Sale (POS)",
    "asc": "Aufsteigend",
    "assignee": "Zuständige Person",
    "assignTicket": "\"{name}\" zuweisen",
    "assignTicketStatic": "Dem Ticket zuweisen",
    "attachedDocuments": "Angehängte Dokumente",
    "attachment": "Anhang",
    "attachments": "Anhänge",
    "autoAssigned": "Automatisch zugewiesen",
    "automaticAdjustment": "Automatische Anpassung",
    "backPayment": "Nachzahlung",
    "bankName": "Bankname",
    "batchClassify": "Batch-Klassifizierung von Dokumenten",
    "bic": "BIC",
    "boardName": "Vorstandsname",
    "booleanValue": "Boolean-Wert",
    "booleanValueShort": "Bool",
    "branchnumber": "Branchennummer",
    "brevoApiKey": "Brevo API Key",
    "brevoCc": "Empfänger Kopie",
    "brevoReplyTo": "Antworten",
    "brevoSelectedTemplate": "Ausgewählte Vorlage",
    "brevoTemplate": "Email-Vorlage",
    "brevoTo": "Senden an",
    "calculationStartDate": "Berechnungsbeginn",
    "caretaker": "Verwalter",
    "ccRecipients": "CC Empfänger",
    "changeClassification": "Klassifikation ändern",
    "changedAt": "Aktualisiert",
    "changes": "Änderungen",
    "chartCollapseAll": "Alle reduzieren",
    "chartExpandAll": "Alle erweitern",
    "chartFromStore": "letze Ansicht wiederherstellen",
    "checklistItems": "Checkliste",
    "checklistTopic": "Prüfbedingung",
    "checksumSHA256": "Prüfsumme",
    "children": "Unterpositionen",
    "chooseFile": "Datei auswählen",
    "chooseFiles": "Dateien auswählen",
    "city": "Stadt",
    "cityName": "Stadtname",
    "cityZip": "Stadt PLZ",
    "classificationStatus": "Status",
    "code": "Code",
    "columnName": "Spaltenname",
    "combinedCount": "Zählt",
    "combinedExtensionValue": "Verlängerung",
    "combinedNoticePeriod": "Kündigungsfrist",
    "combinedValue": "Bedingungswert",
    "comment": "Kommentar",
    "commentPublic": "Fur Kunden sichtbar",
    "comments": "Kommentare",
    "commentText": "Komentartext",
    "companies": "Unternehmen",
    "company": "Unternehmen",
    "companyCount": "Anzahl der Unternehmen",
    "companyCountShort": "Anz.",
    "companyName": "Unternehmensname",
    "complete": "Abschließen",
    "conditions": "Vertragsbedingungen",
    "conditionType": "Bedingungstyp",
    "conditionTypeId": "Bedingungstyp-ID",
    "connectedBy": "Verknüpft durch {source}",
    "constructionYear": "Baujahr",
    "consumerPriceIndex": "Preisindex",
    "contact": "Kontakt",
    "contactPerson": "Ansprechpartner",
    "contactPersonToContract": "Ansprechpartner",
    "contains": "Enthält",
    "content": "Inhalt",
    "contract": "Vertrag",
    "contractAction": "Vertragsaktion",
    "contractactions": "Vertragsaktionen",
    "contractClauses": "Vertragsbedingungen",
    "contractConditions": "Vertragsbedingungen",
    "contractId": "ID des Vertrags",
    "contractIdShort": "Vertr.ID",
    "contractingParties": "Vertragsparteien",
    "contractName": "Vertragsname",
    "contractNames": "Verträge",
    "contracts": "Verträge",
    "contractsAreaValidity": "Geltungsbereich",
    "contractsDates": "Gültigkeitszeitraum",
    "contractsHeader": "Vertragskopf",
    "contractsParties": "Vertragsparteien",
    "contractsPartiesGiver": "Vertragsgeber",
    "contractsPartiesTaker": "Vertragsnehmer",
    "contractTemplate": "Vertragsvorlage",
    "contracttodocuments": "Dokumente",
    "contractType": "Vertragstyp",
    "contractTypeId": "Vertragstyp-ID",
    "contradictionPackages": "Widerspruchspakete",
    "contributionOneTime": "einmaliger Beitrag",
    "contributionRecurring": "wiederkehrender Beitrag",
    "cost": "Kosten",
    "costCenter": "Kostenstelle",
    "costsNet": "Kosten (Netto)",
    "country": "Land",
    "countryCode": "Ländercode",
    "countryName": "Ländername",
    "createdAt": "Erstellt am",
    "currency": "Währung",
    "customer": "Kunde",
    "customerAddress": "Adresse",
    "customerAmount": "Betrag Kunde netto",
    "customerAmountShort": "Betr. Kd.",
    "customerAmountSuggestion": "Ursprüngliche Summe",
    "customerArea": "Fläche Kunde",
    "customerAreaShort": "Fläche",
    "customerUnit": "Menge Kunde",
    "customerBankingAccount": "Bankkonto",
    "customerCode": "Filialnummer Kunde",
    "customerCount": "Anzahl der Kunden",
    "customerCountry": "Land Kunde",
    "customerCountShort": "Anz.",
    "customerGroup": "Kundengruppe",
    "customergroupDescription": "Beschreibung",
    "customerGroupId": "Kundengruppen-ID",
    "customerGroupName": "Kundengruppe",
    "customergroupName": "Kundengruppenname",
    "customergroupNameShort": "Name",
    "customerGroups": "Kundengruppen",
    "customerId": "Kunden-ID",
    "customerIdShort": "Kd-ID",
    "customerName": "Filialname Kunde",
    "customerPrepaymentGross": "Vorauszahlungen Kunde (Brutto)",
    "customerPrepaymentNet": "Vorauszahlungen Kunde (Netto)",
    "customers": "Kunden",
    "customerTemplate": "Kundenvorlage",
    "customerUnitArea": "Kundeneinheit",
    "dateValue": "Datum",
    "dayOfMonth": "Tag des Monats",
    "deActivate": "Deaktivieren",
    "deactivate": "Deaktivieren",
    "deadline": "Frist",
    "deadlineOffset": "Fristversatz",
    "deadlineOverdue": "Frist überfällig",
    "deadlineRisk": "Fristrisiko",
    "definiteActionEnd": "Letzter möglicher Stornierungstermin",
    "delete": "Löschen",
    "deleteMany": "Lösche {count} Eintrag | Lösche {count} Einträge",
    "desc": "Absteigend",
    "description": "Beschreibung",
    "descriptionUiPluginParam": "Beispielbeschreibung",
    "detailDescription": "Detailbeschreibung",
    "difference": "Differenz",
    "discountPercentage": "Nachlass",
    "document": "Dokument",
    "documentId": "Dokument-ID",
    "documentName": "Dokumentenname",
    "documentReviewDeadline": "Frist Belegeinsicht",
    "documents": "Dokumente",
    "documentType": "Dokumenttyp",
    "documentTypes": "Art des Dokuments",
    "documentVersion": "Version Dokument",
    "documentVersionShort": "V. Doc.",
    "downloadableTemplates": "Downloadbare Vorlagen",
    "earliestEffectiveDate": "Frühestes Wirksamkeitsdatum",
    "edit": "Bearbeiten",
    "editorName": "Bearbeiter:in",
    "effectiveDate": "Gültigkeitsdatum",
    "eMail": "E-Mail",
    "email": "E-Mail",
    "emailId": "Email-ID",
    "emailLink": "E-Mail link",
    "emails": "E-Mails",
    "endDate": "Enddatum",
    "endsWith": "Endet mit",
    "entryDate": "Eingangsdatum",
    "enumValue": "Enum-Wert",
    "enumValueShort": "Enum",
    "equals": "Gleich",
    "eventType": "Ereignis",
    "exportAll": "alle",
    "exportAllColumns": "alle",
    "exportColumnScope": "Spalten",
    "exportDataType": "Datenformat",
    "exportFiltered": "gefiltert",
    "exportFormatted": "formatiert",
    "exportLimit": "Exportlimit",
    "exportRaw": "roh",
    "exportScope": "Datensätze",
    "exportVisibleColumns": "sichtbare",
    "extension": "Verlängerung",
    "extensionUnit": "Verlängerungseinheit",
    "extensionValue": "Verlängerungsoption",
    "extensionValueShort": "Verl.",
    "extra": "Extra",
    "favAdd": "Als Favorit speichern",
    "favRemove": "Favorit entfernen",
    "field": "Feld",
    "fieldsToExport": "Felder zum Exportieren",
    "fileName": "Dateiname",
    "filter": "Filter",
    "filtered": "gefiltert",
    "filterOnPOS": "Filter auf Verkaufsstelle",
    "filters": "Filter",
    "firstName": "Vorname",
    "firstPossibleEndDate": "Erstes mögliches Enddatum",
    "firstYear": "Erstes Jahr",
    "forCustomers": "für Kunden",
    "generalLeaderAccount": "Sachkonto",
    "generalLeaderAccountNr": "Sachkontonummer",
    "germanFederalState": "Bundesland",
    "grandTotal": "Gesamtsumme",
    "greaterThan": "Größer als",
    "greaterThanOrEqual": "Größer oder gleich",
    "group": "Gruppe",
    "handOverDate": "Übergabedatum",
    "hasInternetOrPhone": "Hat Internet oder Telefon",
    "hasNotifications": "Benachrichtigungen",
    "history": "Verlauf",
    "houseNumber": "Hausnummer",
    "iban": "IBAN",
    "ibanId": "IBAN ID",
    "id": "ID",
    "includeAllAttachments": "Alle Anhänge einbeziehen",
    "includedInContract": "Im Vertrag enthalten",
    "indexChange": "Änderung",
    "indexClauseDetails": "Details zur Indexklausel",
    "indexTransfer": "Weitergabe",
    "inlineDocuments": "Inline-Dokumente",
    "internal": "Intern",
    "internalObjectionDeadline": "Frist Widerspruch It. SFM",
    "interval": "Intervall",
    "intervalUnit": "Intervall-Einheit",
    "inventoryNumber": "Inventarnummer",
    "invoice": "Rechnung",
    "invoiceId": "Rechnungs-ID",
    "invoiceIssueDate": "Ausstellungsdatum Rechnung",
    "invoiceIssueDates": "Rechnungsstellungsdaten",
    "invoiceIssueDatesShort": "RN-Datum",
    "invoiceIssuerLegalName": "NK Name",
    "invoiceItemSource": "Quelle",
    "invoiceObjectionDeadline": "Frist Widerspruch",
    "invoicePeriodEnd": "Ende Rechnungszeitraum",
    "invoicePeriodEnds": "Rechnungszeitraum endet",
    "invoicePeriodEndsShort": "Bis",
    "invoicePeriodStart": "Beginn Rechnungszeitraum",
    "invoicePeriodStarts": "Rechnungszeitraum beginnt",
    "invoicePeriodStartsShort": "Von",
    "invoiceShort": "RN",
    "isActive": "Aktiv",
    "isActiveValue": "Aktiv",
    "isAlwaysVisible": "immer sichtbar",
    "isClassificationNotApplicable": "Klassifizierung nicht notwendig",
    "isClassified": "Klassifiziert",
    "isClassifiedShort": "Klass.",
    "isDraft": "Entwurf",
    "isDraftShort": "Entw.",
    "isFlatRate": "Pauschale",
    "isGroupAdmin": "Gruppenadministrator",
    "isHeatingCostsCompliantHKVO": "Heizkosten nach HVO abgerechnet",
    "isIndexPayment": "Indexklausel",
    "isInline": "Anhang",
    "isInternal": "Intern",
    "isMainAccount": "Hauptkonto",
    "isNewTicket": "Neues Ticket erstellen",
    "isOptional": "Optional",
    "isPublic": "Sichtbar für Kunden",
    "isRecurring": "Wiederkehrend",
    "isSeyboldUser": "Seybold-Benutzer",
    "issueDate": "Datum Abrechnung",
    "issueDateShort": "RN-Datum",
    "issuerLegalName": "Name",
    "isTemplateEditable": "Editierbar:",
    "isTemplateEditableFalse": "Platzhalter",
    "isTemplateEditableTrue": "Alles",
    "jobTitle": "Berufsbezeichnung",
    "languageOfCorrespondence": "Korrespondenzsprache",
    "lastAdjustment": "Letzte Anpassung",
    "lastCost": "Letzte Kosten",
    "lastEmailSentAt": "letze Email Datum Versand",
    "lastEmailSentTo": "letze Email gesendet an",
    "lastName": "Nachname",
    "lastPerformedDate": "Letztes Ausführungsdatum",
    "lastPossibleContractEnd": "Letztmögliches Vertragsende",
    "Lease": "Leasing",
    "lessThan": "Kleiner als",
    "lessThanOrEqual": "Kleiner oder gleich",
    "lineItem": "Widerspruchsposten",
    "lineItemName": "Positionsname",
    "lineItemNameShort": "Name",
    "lineItemPositionName": "Positionsname (intern)",
    "lineItemPositionNameShort": "int. Name",
    "lineItemStatus": "Positions-Status",
    "lineItemStatusShort": "klar?",
    "location": "Standort",
    "locationAddress": "Adresse",
    "locationArea": "Bereich",
    "locationId": "Standort-ID",
    "locationIdShort": "Loc-ID",
    "locationName": "Standortname",
    "locations": "Standorte",
    "locationToPartner": "Partner",
    "logText": "Lognachricht",
    "mailContent": "E-Mail-Inhalt",
    "mailTemplate": "E-Mail-Vorlage",
    "Maintenance Contract": "Wartungsvertrag",
    "maintenanceStatuses": "Wartungsstatus",
    "mainUsage": "Hauptnutzung",
    "managerName": "Managername",
    "manufacturer": "Hersteller",
    "markAsUnread": "Als ungelesen markieren",
    "markDone": "Als erledigt markieren",
    "maxCount": "Maximale Anzahl Verlängerung",
    "maxCountShort": "Max. Anz.",
    "message": "Nachricht",
    "mimeType": "Dokumenttyp",
    "mobile": "Mobil",
    "model": "Modell",
    "modified": "verändert",
    "modifiedAt": "Geändert am",
    "month": "Monat",
    "moveinTime": "Einzugszeit",
    "moveoutTime": "Auszugszeit",
    "name": "Name",
    "nameExternal": "Extern",
    "nameOnStatement": "Bezeichnung Kostenart lt. SFM",
    "negotiationAll": "alle",
    "negotiationGreen": "grün",
    "negotiationNone": "keine",
    "negotiationRed": "rot",
    "negotiationYellow": "gelb",
    "new": "Neu",
    "newChildPosition": "Neue Unterposition",
    "newTicket": "Neues Ticket",
    "nextDueDate": "Nächster Fälligkeitstermin",
    "nextPossibleContractEnd": "Nächstmögliches Vertragsende",
    "nextStepAction": "Nächster Schritt",
    "no": "Nein",
    "noAttachments": "Keine Anhänge",
    "noPlugins": "Keine Plugins",
    "note": "Notiz",
    "notes": "Notizen",
    "noteText": "Notiztext",
    "notice": "Hinweis",
    "noticePeriod": "Kündigungsfrist",
    "noticePeriodShort": "Frist",
    "noticePeriodUnit": "Einheit der Kündigungsfrist",
    "noTicketFound": "Kein Ticket gefunden",
    "notIncluded": "Nicht enthalten",
    "noTriggers": "Keine Trigger",
    "number": "Nummer",
    "numberOfUses": "Anzahl der Verwendungen",
    "numberValue": "Zahlenwert",
    "numberValueShort": "Zahl",
    "objectionDeadline": "Frist Widerspruch",
    "objectionItemStatus": "Einspruch-Status",
    "objectionItemStatusShort": "geklärt?",
    "objectionStatus": "Einspruchsstatus",
    "offerGreenAdditionalConcession": "Entgegenkommen Extra",
    "offerGreenAdditionalConcessionShort": "Extra",
    "offerGreenMaxDemand": "Maximalforderung",
    "offerGreenMaxDemandShort": "Max",
    "offerGreenSolutionProposal": "Lösungsvorschlag",
    "offerGreenSolutionProposalShort": "Lösung",
    "offerGreenStandardConcession": "Entgegenkommen Standard",
    "offerGreenStandardConcessionShort": "Standard",
    "offerRedAdditionalConcession": "Entgegenkommen Extra",
    "offerRedAdditionalConcessionShort": "Extra",
    "offerRedMaxDemand": "Maximalforderung",
    "offerRedMaxDemandShort": "Max",
    "offerRedSolutionProposal": "Lösungsvorschlag",
    "offerRedSolutionProposalShort": "Lösung",
    "offerRedStandardConcession": "Entgegenkommen Standard",
    "offerRedStandardConcessionShort": "Standard",
    "offerYellowAdditionalConcession": "Entgegenkommen Extra",
    "offerYellowAdditionalConcessionShort": "Extra",
    "offerYellowMaxDemand": "Maximalforderung",
    "offerYellowMaxDemandShort": "Max",
    "offerYellowSolutionProposal": "Lösungsvorschlag",
    "offerYellowSolutionProposalShort": "Lösung",
    "offerYellowStandardConcession": "Entgegenkommen Standard",
    "offerYellowStandardConcessionShort": "Standard",
    "oneTimeContribution": "Betrag einmalig",
    "operatingcostinvoice": "Nebenkostenabrechnung",
    "operator": "Operator",
    "optional": "optional",
    "optionsAvailable": "Optionen verfügbar",
    "orderBy": "Sortieren nach",
    "overdue": "überfällig",
    "overdueDaysSince": "Überfällig",
    "ownerName": "Eigentümername",
    "page": "Seite",
    "parentId": "Eltern-ID",
    "partnephonerCount": "Anzahl Partnergruppen",
    "partnephonerCountShort": "PGs",
    "partner": "Partner",
    "partnerAddress": "Adresse",
    "partnerBankingAccount": "Partner-Bankkonto",
    "partnercompany": "Gruppenzuordnung",
    "partnerCount": "Partneranzahl",
    "partnerCountShort": "Anz.",
    "partnerGroup": "Partnerunternehmen",
    "partnerGroupId": "Partnergruppen-ID",
    "partnerGroupIdShort": "Pg-ID",
    "partnerGroups": "Partnergruppen",
    "partnerName": "Partnername",
    "partners": "Partner",
    "passThrough": "Durchlauf",
    "payment": "Zahlung",
    "payments": "Zahlungen",
    "paymentType": "Zahlungsart",
    "performedDate": "Durchführungsdatum",
    "periodEnd": "Ende Abrechnungszeitraum",
    "periodEndShort": "Abr. bis",
    "periodStart": "Beginn Abrechnungszeitraum",
    "periodStartShort": "Abr. von",
    "phone": "Telefon",
    "phoneOrInternetType": "Art von Internet oder Telefon",
    "pointOfSale": "Verkaufsstelle",
    "pointOfSale_customer_customerGroup_name": "Kundengruppe",
    "pointOfSale_name": "Verkaufsstelle",
    "pointOfSaleId": " ID",
    "pointOfSaleName": "POS-Name",
    "pointOfSaleNames": "POS",
    "pointOfSaleNameShort": "Name",
    "pointOfSales": "Verkaufsstelle",
    "pointOfSalesToArea": "Bereiche",
    "pos": "POS",
    "posId": "ID Point Of Sale",
    "posIdShort": "POS ID",
    "positionCount": "Anzahl Positionen",
    "positionCountShort": "Anz. Pos.",
    "positionEndDates": "Enddatum",
    "positionIds": "Positions-IDs",
    "positionNames": "Positionsbezeichnungen",
    "positionNamesShort": "Posten",
    "positions": "Widerspruchspositionen",
    "positionStartDates": "Startdatum",
    "posName": "Point of Sale (POS)",
    "postalCode": "Postleitzahl",
    "postalCodeShort": "PLZ",
    "postCleaningIsRequired": "Nachreinigung erforderlich",
    "preferences": {
      "showContractactionsTable": "Vertragsaktionen",
      "showEmailsDoughnutChart": "Emailchart",
      "showEmailsUnclassifiedTable": "Unklassifizierte Emails",
      "showLatestOpenTicketsTable": "Aktuelle offene Tickets",
      "showTicketsDoughnutChart": "Ticketchart",
      "showUrgentOpenTicketsTable": "Dringende offene Tickets",
      "ticketShowConfirm": "Nächsten Schritt bestätigen",
      "ticketShowPersonalNotes": "Eigene Notizen",
      "ticketShowPreviewNotification": "Vorschau auf nächsten Schritt"
    },
    "preferenceSettings": "Einstellungen",
    "preferenceSettingsDashboard": "Dashboardeinstellungen",
    "preferenceSettingsTicket": "Ticketeinstellungen",
    "priorityLevel": "Priorität",
    "privateComment": "Privat",
    "procdefUrl": "Prozessschritt-URL",
    "processAddStep": "Neuen Schritt erstellen",
    "processAddStepConnect": "Erstelle neuen Schritt und verknüpfe ihn",
    "processAddUiPlugin": "Aktionskomponente hinzufügen",
    "processAssignedTeam": "Zugewiesenes Team",
    "processAssignToNewStep": "Zu neuem Schritt zuweisen",
    "processConnectPlugin": "UI-Plugin verknüpfen",
    "processConnectStep": "Neue Option erstellen",
    "processDeadline": "Frist für gesamten Prozess (in Arbeitstagen)",
    "processDeadlinedAt": "Finale Frist",
    "processDownload": "Download Prozess-JSON",
    "processExternal": "Externer Prozess",
    "processFinishTask": "Task abschliessen",
    "processGotoExternalStep": "Zu extrenem Prozess wechseln",
    "processGotoStart": "Zurück zum Startpunkt",
    "processInitTitle": "Benennen und beschreiben Sie den Prozess",
    "processIsExternalStep": "Ist ein externer Prozessschritt",
    "processIsUploaded": "Hochgeladen:",
    "processLoadFromJSON": "Prozess laden",
    "processName": "Prozess",
    "processNewOption": "Neue Option",
    "processOptionName": "Text der Verknüpfung",
    "processOptionNextStep": "Prozessschritt-Verknüpfung",
    "processOptionNextStepAssignTeam": "Teamzuweisung",
    "processOptionsNextStep": "Optionen nächste Schritte",
    "processPasteJSON": "JSON hineinkopieren",
    "processPreview": "Vorschau",
    "processRemoveOption": "Option entfernen",
    "processRemovePlugin": "Plugin entfernen",
    "processRemoveTrigger": "Trigger entfernen",
    "processSlip": "Laufzettel",
    "processStep": "Schritt",
    "processStepDelete": "Schritt löschen",
    "processStepDescription": "Beschreibung des Prozessschrittes",
    "processStepEdit": "Schritt bearbeiten",
    "processStepIsEnd": "Ist Endpunkt",
    "processStepName": "Prozessschritt Name",
    "processStepTriggers": "Trigger mit Schritt verknüpfen",
    "processStepUiPlugins": "Aktionskomponenten",
    "processTree": "Organigramm",
    "processUnlinkOption": "Verweis entfernen",
    "processUploadJSON": "JSON hochladen",
    "profile": "Profil",
    "propertyDescription": "Beschreibung",
    "publicComment": "Offentlich",
    "Purchase Agreement": "Kaufvertrag",
    "rawdata": "Rohdaten",
    "receiptDate": "Eingangsdatum",
    "receiveDate": "Eingangsdatum",
    "recentComments": "Letzte Kommentare",
    "recurringContribution": "Betrag wiederkehrend",
    "recurringPayment": "Wiederkehrende Zahlungen",
    "reference": "Referenz",
    "region": "Region",
    "remaining": {
      "farFuture": "In ferner Zukunft",
      "lessThanHalfYear": "Weniger als ein halbes Jahr",
      "lessThanMonth": "Weniger als ein Monat",
      "lessThanQuarter": "Weniger als ein Vierteljahr",
      "lessThanYear": "Weniger als ein Jahr"
    },
    "Rental": "Vermietung",
    "rentalSpace": "Mietfläche",
    "reply": "Antworten",
    "resiliationDate": "Beendigungsdatum",
    "resolvedConditionType": "Bedingungstyp",
    "responsibleRole": "Verantwortliche Rolle",
    "retroactiveAdjustment": "Rückwirkende Anpassung",
    "reviewer1Date": "Datum 1. Prüfung",
    "reviewer1Name": "Name 1. Prüfer:in",
    "reviewer2Date": "Datum 2. Prüfung",
    "reviewer2Name": "Name 2. Prüfer:in",
    "reviewPhase": "Prüfphase",
    "role": "Rolle",
    "salutation": "Anrede",
    "secondStampingNotOk": "Ungeprüft",
    "selectAll": "Alle auswählen",
    "selectContract": "Vertrag auswählen",
    "selected": "Ausgewählt",
    "selectedColumns": "Ausgewählte Spalten",
    "selectPointOfSale": "Verkaufsstelle auswählen",
    "senderEmail": "E-Mail",
    "senderEmails": "E-Mails",
    "senderName": "Absender",
    "serialNumber": "Seriennummer",
    "Service Agreement": "Servicevertrag",
    "serviceconditions": "Vertragsbedingungen",
    "servicecontact": "Kontakt",
    "servicecontractactions": "Vertragsaktionen",
    "serviceobjectdocuments": "Dokumente",
    "serviceobjectmaintenances": "Wartungseinträge",
    "serviceobjectmaintenancestatus": "Wartungsstatus",
    "serviceobjectpartners": "Partner",
    "serviceObjects": "Serviceobjekte",
    "serviceObjectTemplate": "Dienstleistungsobjektvorlage",
    "serviceobjecttickets": "Tickets",
    "serviceObjectTypes": "Serviceobjektarten",
    "servicepayment": "Zahlung",
    "settlementResultGross": "Abrechnungsergebnis (Brutto)",
    "settlementResultNet": "Abrechnungsergebnis (Netto)",
    "sfmPosition": "SFM Position",
    "sfmpositionchildren": "Unterpositionen",
    "sfmPositionName": "SFM Positionsname",
    "shortDescription": "Kurze Beschreibung",
    "showList": "Liste anzeigen",
    "signatureNotOk": "Nicht vollständig unterzeichnet",
    "signatureOk": "Unterzeichnet",
    "signatureRequestNotOk": "Noch nicht unterschriftsreif",
    "signatureRequestOk": "Unterschriftsreif",
    "signatureRequestPending": "Unterschrift ausstehend",
    "signatureRequestRefused": "Unterschrift abgelehnt",
    "signatureRequests": "Yousign Unterschriften",
    "signerAdd": "Weiterer Unterzeichner",
    "signerCustom": "Benutzerdefiniert",
    "signerCustomer": "Kunde",
    "signerDefault": "Standard-Erstunterzeichner",
    "signerFirst": "Erstunterzeichner",
    "signerFollowUp": "{count}. Folgeunterzeichner",
    "size": "Größe",
    "sizeShort": "G.",
    "skip": "Überspringen",
    "solutionProposals": "Lösungsvorschläge",
    "spaceValue": "Flächenwert",
    "stamped": "Gestempelt",
    "stampedShort": "Gest.",
    "stampingNotOk": "Ungestempelt",
    "stampingStep1": "Erste Prüfung",
    "stampingStep2": "Zweite Prüfung",
    "startDate": "Startdatum",
    "startsWith": "Beginnt mit",
    "statedCustomerPrepaymentNet": "Vorauszahlung Abrechnung",
    "status": "Status",
    "statusActions": "Aktionen",
    "stepActionElement": "UI-Plugin",
    "stepDeadline": "Frist für diesen Schritt (in Arbeitstagen)",
    "stepDeadlinedAt": "Zu erledigen bis",
    "stepLinkname": "Handlungsoption",
    "stepTriggerElement": "Trigger",
    "street": "Straße",
    "streetNumber": "Straßennummer",
    "stringValue": "String-Wert",
    "subject": "Betreff",
    "sumAreaSpaces": "SUM-Bereichsflächen",
    "summary": "Zusammenfassung",
    "supposedActionEnd": "Vermutetes Aktionsende",
    "tableSettingsFontsize": "Schriftgröße",
    "tableSettingsFooterPagination": "Paginierung im Footer",
    "tableSettingsGrid": "Raster",
    "tableSettingsHdlBehaviour": "Tabellenverhalten",
    "tableSettingsHdlColumns": "Sichtbare Spalten",
    "tableSettingsHdlExportCSV": "Export als CSV",
    "tableSettingsHdlLayout": "Tabellenlayout",
    "tableSettingsHdlSize": "Größe",
    "tableSettingsInstantEdit": "Express-Editierung",
    "tableSettingsMultiselect": "Multiselect-Checkboxen",
    "tableSettingsStripedRows": "Gestreift",
    "tabsAll": "Alle",
    "tags": "Tags",
    "tasks": "Aufgaben",
    "taxinvoices": "TA-Rechnungen",
    "team": "Zugewiesenes Team",
    "teamDescription": "Teambeschreibung",
    "teamName": "Teamname",
    "teams": "Teams",
    "templateIsForced": "Festes Template",
    "threshold": "Schwellenwert",
    "ticket": "Ticket",
    "ticketId": "Verknüpftes Ticket",
    "ticketIdShort": "Ticket",
    "ticketLinked": "Verknüpftes Ticket",
    "ticketLinkedShort": "Ticket",
    "ticketNumber": "Ticketnummer",
    "tickets": "Tickets",
    "ticketStatus": "Ticketstatus",
    "title": "Titel",
    "titleUiPluginParam": "Beispieltitel",
    "toRecipients": "An Empfänger",
    "total": "Summe",
    "totalAccumulatedMaintenanceCosts": "Gesamte aufgelaufene Wartungskosten",
    "totalAmount": "Gesamtbetrag",
    "totalAmountShort": "Summe",
    "totalArea": "Gesamtfläche",
    "totalAreaShort": "m²",
    "totalUnit": "Gesamtmenge",
    "type": "Typ",
    "typeName": "Typname",
    "typeOfUse": "Nutzungsart",
    "unit": "Einheit",
    "unitName": "Einheitenname",
    "unitValues": {
      "CubicMeter": "Kubikmeter",
      "DegreeDays": "Gradtage",
      "Hours": "Stunden",
      "Kilogram": "Kilogramm",
      "KilowattHours": "Kilowattstunden",
      "Percent": "Prozent",
      "Piece": "Stück",
      "SquareMeter": "Quadratmeter"
    },
    "unrelatedAttachments": "Unabhängige Anhänge",
    "upload": "Datei hochladen",
    "uploaded": "Hochgeladen",
    "uploadedAmount": "Ein Dokument hochgeladen|{count} Dokumente hochgeladen",
    "uploadedDocument": "Hochgeladenes Dokument",
    "uploadedNone": "Keine Dokumente hochgeladen",
    "uploadFile": "Datei hochladen",
    "uploadFiles": "Dateien hochladen",
    "usageType": "Nutzungsart",
    "usageTypeAllocationspaceValue": "Zuweisungsflächenwert",
    "usageTypeMainUsage": "Hauptnutzung",
    "usagetypeName": "Nutzungsartname",
    "usageTypeRentalspaceValue": "Mietflächenwert",
    "usageTypeValidFrom": "Gültig ab",
    "usageTypeValidTo": "Gültig bis",
    "userEmail": "E-Mail: {email}",
    "userName": "Benutzername: {userName}",
    "users": "Benutzer",
    "validFrom": "Gültig ab",
    "validTo": "Gültig bis",
    "value": "Wert",
    "vat": "Umsatzsteuer-Identifikationsnummer",
    "vatRate": "Steuersatz",
    "vatRateShort": "MwSt.",
    "version": "Version",
    "versionAddress": "Adressversion",
    "versionAddressShort": "VA",
    "versionShort": "V.",
    "view": "Ansehen",
    "viewlengthLimit": "Maximale Anzahl Einträge",
    "widgetIsClassifiedFalse": "unbearbeitet",
    "widgetIsClassifiedTrue": "bearbeitet",
    "widgetStatusTICKETSTATUS_CLOSED": "bearbeitet",
    "widgetStatusTICKETSTATUS_NEW": "unbearbeitet",
    "withAttachments": "Mit Anhängen",
    "withoutAttachments": "Anhänge separat",
    "year": "Jahr",
    "yes": "Ja",
    "youSignApiKey": "Yousign API key",
    "zip": "Postleitzahl"
  },
  "messages": {
    "checklistAllChecked": "Alle Punkte sind abgehakt",
    "checklistNotAllChecked": "Nicht alle Punkte sind abgehakt",
    "contractsLastCreated": "Zuletzt erstellte Verträge",
    "contractsPluginReady": "Es ist bereits ein Vertrag vorhanden. | Es sind {count} Verträge vorhanden",
    "createdByTicket": "Erstellt durch Ticket",
    "documentDetailClassificationAttachment": "Da dieses Dokument ein Anhang ist, sind Verkaufsstelle, Dokumenttyp und Ticket entweder alle erforderlich oder keiner von ihnen.",
    "documentDetailClassificationUploadedDocument": "Da dieses Dokument ein hochgeladenes Dokument ist, sind Verkaufsstelle und Dokumenttyp erforderlich. Das Ticket ist optional.",
    "documentEncrypted": "Das Dokument ist verschlüsselt und kann nicht verarbeitet werden. Wir arbeiten an der Unterstützung verschlüsselter Dokumente in zukünftigen Versionen.",
    "loadingPDF": "PDF wird geladen",
    "noData": "Keine Daten vorhanden",
    "noInlinePreview": "Keine Vorschau verfügbar",
    "noResults": "Keine Ergebnisse",
    "noTableData": "Keine Daten vorhanden",
    "noTableFilterData": "Kein Ergebnis für diese Filtereinstellung",
    "toggledFullscreenView": "Auf Eimzelansicht gewechselt",
    "toggledSplitView": "Auf geteilte Ansicht gewechselt",
    "uiPluginAllChecked": "Aufgabe ist erledigt",
    "uiPluginNotAllChecked": "Aufgabe ist nicht vollständig erledigt",
    "viewmode": "Ansichtsmodus"
  },
  "months": {
    "1": "Januar",
    "2": "Februar",
    "3": "März",
    "4": "April",
    "5": "Mai",
    "6": "Juni",
    "7": "Juli",
    "8": "August",
    "9": "September",
    "10": "Oktober",
    "11": "November",
    "12": "Dezember"
  },
  "navigation": {
    "access": "Zugriff",
    "accountDataRelated": "Kontodatenbezogen",
    "address": "Adresse",
    "administration": "Verwaltung",
    "areas": "Flächen",
    "areaTypes": "Gebietstypen",
    "attributeTranslations": "Attribut-Übersetzungen",
    "authorizations": "Berechtigungen",
    "choices": "Auswahlmöglichkeiten",
    "cities": "Städte",
    "claimTypes": "Anspruchsarten",
    "classificationOfDocumentEntries": "Eingang",
    "companies": "Unternehmen",
    "company": "Seybold intern",
    "companyDatabase": "Kunden",
    "conditionList": "Bedingungsliste",
    "configuration": "Konfiguration",
    "contactPerson": "Ansprechpartner",
    "contactsCustomers": "Kontakte",
    "contactsInternal": "Kontakte",
    "contactsPartners": "Kontakte",
    "contractCriteriaTypes": "Vertragskriterienarten",
    "contractDataRelated": "Vertragsdatenbezogen",
    "contracts": "Verträge",
    "contractsTermsAndConditions": "Verträge - Bedingungen und Konditionen",
    "contractTitles": "Vertragstitel",
    "contractTypes": "Vertragsarten",
    "contradictionPackages": "Widerspruchspakete",
    "costinvoiceobjections": "Widersprüche NK-Abrechnung",
    "costTypes": "Kostenarten",
    "countries": "Länder",
    "criteriaAndChoices": "Kriterien und Auswahlmöglichkeiten",
    "crud": "CRUD",
    "currencies": "Währungen",
    "customergroups": "Gruppen",
    "customers": "Kunden",
    "dashboard": "Dashboard",
    "dashboardOfBoards": "Dashboard der Boards",
    "dashboardTickets": "Dashboard-Tickets",
    "deadlineList": "Fristenliste",
    "documentContractType": "Dokumentenvertragsart",
    "documents": "Dokumente",
    "documentTypes": "Dokumenttypen",
    "facilityServices": "Gebäudeverwaltung",
    "favorites": "Favoriten",
    "functions": "Funktionen",
    "geography": "Orte",
    "import": "Import",
    "importContract": "Importvertrag",
    "importFunction": "Importfunktion",
    "importStandard": "Importstandard",
    "inbox": "Eingang",
    "indexClauses": "Indexklauseln",
    "inspectionResults": "Inspektionsergebnisse",
    "invoiceAndContradictionData": "Rechnungs- und Widerspruchsdaten",
    "invoiceCriteria": "Rechnungs-Kriterien",
    "invoiceValueTypes": "Rechnungswertarten",
    "kanbanTickets": "Kanban-Tickets",
    "kanbanTicketsConfiguration": "Kanban-Tickets",
    "language": "Sprache",
    "languages": "Sprachen",
    "listOfTicketsAndTasks": "Liste der Tickets und Aufgaben",
    "locations": "Standorte",
    "locationTypes": "Standorttypen",
    "logout": "Abmelden",
    "main": "Mein Zelos",
    "masterdata": "Stammdaten",
    "maturityTypes": "Fälligkeitstypen",
    "menu": "Menü",
    "miscellaneous": "Verschiedenes",
    "monthlyindex": "Monatlicher Index",
    "myTasksAndTickets": "Meine Aufgaben und Tickets",
    "myTasksAndTicketsConfiguration": "Meine Aufgaben und Tickets",
    "newBusiness": "Neues Geschäft",
    "objectDataRelated": "Objektdatenbezogen",
    "operatingcostinvoices": "Betriebskostenrechnungen",
    "operations": "Betrieb",
    "partnerCompanies": "Partnerunternehmen",
    "partnercompanyDatabase": "Partner",
    "partnergroups": "Gruppen",
    "partners": "Partner",
    "partnerTypes": "Partnerarten",
    "payments": "Zahlungen",
    "pointOfSales": "Point of Sale (POS)",
    "pointofsales": "Point of Sale (POS)",
    "processes": "Prozesse",
    "products": "Produkte",
    "rating": "Bewertung",
    "recurringPayment": "Wiederkehrende Zahlungen",
    "recurringPaymentTypes": "Typen wiederkehrender Zahlungen",
    "rentalsAndContracts": "Dokumente",
    "resultCategories": "Ergebnis-Kategorien",
    "rights": "Rechte",
    "salutions": "Anrede",
    "savingTypes": "Ersparnisarten",
    "servicecontracts": "Serviceverträge",
    "serviceobjects": "Serviceobjekte",
    "serviceObjects": "Serviceobjekte",
    "sfmpositions": "SFM - Positionen",
    "tableGroups": "Tabellengruppen",
    "tables": "Tabellen",
    "tags": "Tags",
    "tapsInvoicePositions": "TAPs - Rechnungspositionen",
    "taxinvoices": "TA - Rechnungen",
    "teams": "Teams",
    "textModules": "Textmodule",
    "textTemplates": "Textvorlagen",
    "textTemplateVariables": "Textvorlagenvariablen",
    "ticketListIssue": "Ticket-Liste Problem",
    "ticketPriorities": "Ticket-Prioritäten",
    "tickets": "Tickets",
    "ticketTypes": "Ticketarten",
    "trackRecord": "Erfolgsbilanz",
    "translations": "Übersetzungen",
    "units": "Einheiten",
    "usageTypes": "Verwendungstypen",
    "userAdministration": "Benutzerverwaltung",
    "userProfile": "Profil",
    "users": "Benutzer",
    "userTypes": "Benutzertypen"
  },
  "pages": {
    "403": {
      "back2Home": "Zur Startseite",
      "headline": "Zugriff nicht gestattet",
      "opener": "Die angefagte Ressource steht Ihnen derzeit nicht zur Verfügung",
      "title": "Zugriff nicht gestattet"
    },
    "404": {
      "back2Home": "Zur Startseite",
      "headline": "Diese Seite existiert nicht",
      "opener": "Überprüfen Sie den Pfad.",
      "title": "Seite nicht gefunden"
    },
    "access": {
      "title": "Zugriff"
    },
    "address": {
      "title": "Adresse"
    },
    "administration": {
      "title": "Administration"
    },
    "areas": {
      "title": "Bereiche"
    },
    "areasDetail": {
      "title": "Bereichsdetails"
    },
    "areasDetailEdit": {
      "title": "Bereich bearbeiten"
    },
    "areasNew": {
      "title": "Neuer Bereich"
    },
    "areaTypes": {
      "title": "Gebietstypen"
    },
    "attributeTranslations": {
      "title": "Attribut-Übersetzungen"
    },
    "authorizations": {
      "title": "Berechtigungen"
    },
    "choices": {
      "title": "Auswahlmöglichkeiten"
    },
    "cities": {
      "title": "Städte"
    },
    "claimTypes": {
      "title": "Anspruchsarten"
    },
    "classification": {
      "actions": "Aktionen",
      "attachmentHeadline": "Mailanhang",
      "emailHeadline": "E-Mail",
      "inbox": "Eingang",
      "message": "Nachricht",
      "selectMessage": "Wählen Sie ein Element aus, um dessen Details anzuzeigen.",
      "tabs": {
        "all": "Alle",
        "received": "Eingang",
        "received:thisWeek": "Diese Woche",
        "received:today": "Heute",
        "status": "Status",
        "status:closed": "Klassifiziert",
        "status:open": "Unbearbeitet"
      },
      "title": "Eingang"
    },
    "classificationOfDocumentEntries": {
      "title": "Klassifizierung der Dokumenteneingänge"
    },
    "classificationOfDocumentEntriesV2": {
      "title": "Klassifizierung der Dokumenteneingänge V2"
    },
    "companies": {
      "title": "Unternehmen"
    },
    "conditionList": {
      "title": "Bedingungsliste"
    },
    "configurationKanbanTickets": {
      "title": "Kanban-Ticket-Konfiguration"
    },
    "contactpersons": {
      "title": "Kontaktpersonen"
    },
    "contactpersonsDetail": {
      "title": "Kontaktpersonendetails"
    },
    "contactpersonsDetailEdit": {
      "title": "Kontaktperson bearbeiten"
    },
    "contactpersonsNew": {
      "title": "Neue Kontaktperson"
    },
    "contractCriteriaTypes": {
      "title": "Vertragskriterienarten"
    },
    "contracts": {
      "extensionValue": "{value} {unit}",
      "headlineExistingContracts": "Bestehende Verträge",
      "headlineNewContract": "Neuer Vertrag",
      "tabs": {
        "contractType": "Vertragstyp",
        "status": "Status",
        "status:available": "Status: Verfügbar"
      },
      "title": "Verträge"
    },
    "contractsDetail": {
      "title": "Vertragsdetails"
    },
    "contractsDetailConditions": {
      "title": "Vertragsbedingungen Detail"
    },
    "contractsDetailConditionsDetailEdit": {
      "title": "Vertragsbedingung bearbeiten"
    },
    "contractsDetailConditionsNew": {
      "title": "Neue Vertragsbedingung"
    },
    "contractsDetailContactEdit": {
      "title": "Kontakt bearbeiten"
    },
    "contractsDetailContactNew": {
      "title": "Neuer Kontakt"
    },
    "contractsDetailContractactions": {
      "title": "Vertragsaktion Details"
    },
    "contractsDetailContractactionsDetailEdit": {
      "title": "Vertragsaktion bearbeiten"
    },
    "contractsDetailContractactionsNew": {
      "title": "Neue Vertragsaktion"
    },
    "contractsDetailEdit": {
      "title": "Vertrag bearbeiten"
    },
    "contractsDetailNew": {
      "title": "Neuer Vertrag"
    },
    "contractsDetailPaymentEdit": {
      "title": "Zahlung bearbeiten"
    },
    "contractsDetailPaymentNew": {
      "title": "Neue Zahlung"
    },
    "contractsNew": {
      "title": "Neuer Vertrag"
    },
    "contractTitles": {
      "title": "Vertragstitel"
    },
    "contractTypes": {
      "title": "Vertragsarten"
    },
    "contradictionPackages": {
      "title": "Widerspruchspakete"
    },
    "costInvoice": {
      "tabs": {
        "status": "Status",
        "status:clear": "Klar",
        "status:unclear": "Unklar"
      },
      "title": "Nebenkostenabrechnung"
    },
    "costinvoiceobjections": {
      "selectLineItem": "Wählen Sie eine Abrechnungsposition",
      "tabs": {
        "negotiationStatus": "Verhandlungsphase",
        "status": "Einspruch Status"
      },
      "title": "Widersprüche NK-Abrechnung"
    },
    "costinvoiceobjectionsDetail": {
      "title": "Widerspruch Details"
    },
    "costinvoiceobjectionsDetailEdit": {
      "title": "Widerspruch bearbeiten"
    },
    "costinvoiceobjectionsNew": {
      "title": "Neuer Widerspruch"
    },
    "costTypes": {
      "title": "Kostenarten"
    },
    "countries": {
      "title": "Länder"
    },
    "criteriaAndChoices": {
      "title": "Kriterien und Auswahlmöglichkeiten"
    },
    "crud": {
      "title": "CRUD"
    },
    "currencies": {
      "title": "Währungen"
    },
    "customergroups": {
      "title": "Kundengruppen"
    },
    "customergroupsDetail": {
      "title": "Kundengruppendetails"
    },
    "customergroupsDetailEdit": {
      "title": "Kundengruppe bearbeiten"
    },
    "customergroupsNew": {
      "title": "Neue Kundengruppe"
    },
    "customers": {
      "tabs": {
        "all": "Alle",
        "group": "Gruppe",
        "received": "Eingang",
        "received:thisWeek": "Diese Woche",
        "received:today": "Heute",
        "status:closed": "Klassifiziert",
        "status:open": "Unbearbeitet"
      },
      "title": "Kunden"
    },
    "customersDetail": {
      "title": "Kundendetails"
    },
    "customersDetailEdit": {
      "title": "Kunde bearbeiten"
    },
    "customersNew": {
      "title": "Neuer Kunde"
    },
    "dashboard": {
      "contractactions": "Vertragsaktionen",
      "emailsChart": "Emails",
      "emailsUnclassified": "Nicht klassifizierte Emails",
      "latestOpenTickets": "Neueste offene Tickets",
      "openTickets": "Offene Tickets",
      "ticketsChart": "Tickets",
      "title": "Mein Zelos",
      "urgentOpenTickets": "Überfällige Tickets"
    },
    "dashboardBoard": {
      "title": "Dashboard Board"
    },
    "dashboardTicket": {
      "title": "Dashboard Ticket"
    },
    "deadlineList": {
      "title": "Fristenliste"
    },
    "documentContractType": {
      "title": "Dokumentenvertragsart"
    },
    "documents": {
      "tabs": {
        "all": "Alle",
        "documentType": "Art",
        "status": "Status",
        "status:classified": "Klassifiziert",
        "status:unclassified": "Unklassifiziert",
        "type": "Typ",
        "type:csv": "CSV",
        "type:documents": "Dokumente",
        "type:excel": "Excel",
        "type:images": "Bilder",
        "type:other": "Sonstige",
        "type:pdf": "PDF",
        "type:word": "Word"
      },
      "title": "Dokumente",
      "uploadedHeadline": "Erfolgreich hochgeladene Dateien",
      "uploadExplanation": "Dateien hierher ziehen um sie hochzuladen",
      "uploadHeadline": "Dokumentenupload",
      "uploadInProgressMessage": "Upload in Arbeit",
      "viewHeadline": "Dokumentenansicht"
    },
    "documentsBatchClassify": {
      "subtitle": "Klassifizieren Sie mehrere Dokumente gleichzeitig",
      "title": "Stapel-Klassifizierung von Dokumenten"
    },
    "documentsDetail": {
      "availableDocuments": "Verfügbare Dokumente",
      "batchClassification": "Stapel-Klassifizierung",
      "title": "Dokument",
      "uploadedHeadline": "Erfolgreich hochgeladene Dateien",
      "uploadExplanation": "Dateien hierher ziehen um sie hochzuladen",
      "uploadHeadline": "Dokumentenupload",
      "uploadInProgressMessage": "Upload in Arbeit",
      "viewHeadline": "Dokumentenansicht"
    },
    "documentTypes": {
      "title": "Dokumenttypen"
    },
    "emails": {
      "headline": "HDL Emails",
      "title": "E-Mails"
    },
    "emailsDetail": {
      "headline": "HDL Detail Email",
      "title": "E-Mail verfassen"
    },
    "emailsNew": {
      "headline": "HDL neue Email",
      "title": "Neue E-Mail"
    },
    "facilityServiceObjects": {
      "title": "Facility-Serviceobjekte"
    },
    "functions": {
      "title": "Funktionen"
    },
    "home": {
      "title": "Startseite"
    },
    "import": {
      "title": "Import"
    },
    "importContract": {
      "title": "Import Vertrag"
    },
    "importStandard": {
      "title": "Import Standard"
    },
    "indexClauses": {
      "title": "Indexklauseln"
    },
    "inspectionResults": {
      "title": "Inspektionsergebnisse"
    },
    "invoiceCriteria": {
      "title": "Rechnungs-Kriterien"
    },
    "invoiceValueTypes": {
      "title": "Rechnungswertarten"
    },
    "languages": {
      "title": "Sprachen"
    },
    "listOfTickets": {
      "title": "Liste der Tickets"
    },
    "locations": {
      "title": "Standorte"
    },
    "locationTypes": {
      "title": "Standorttypen"
    },
    "login": {
      "logInButton": "Mit Entra anmelden",
      "opener": "Sie sind nicht angemeldet. Melden Sie sich mit Ihrem Entra-Account an.",
      "title": "Login"
    },
    "mainKanbanTickets": {
      "title": "Kanban-Boards"
    },
    "mainKanbanTicketsKanbanview": {
      "subtitle": "Aufgaben im Board"
    },
    "mainKanbanTicketsView": {
      "subtitle": "Konfiguration",
      "title": "Kanban-Board"
    },
    "maturityTypes": {
      "title": "Fälligkeitstypen"
    },
    "menu": {
      "title": "Menü"
    },
    "monthlyindex": {
      "tabs": {
        "all": "Alle",
        "year": "Jahr"
      },
      "title": "Monatlicher Index"
    },
    "myTasksAndTickets": {
      "title": "Meine Aufgaben und Tickets"
    },
    "newBusiness": {
      "title": "Neues Geschäft"
    },
    "operatingcostinvoices": {
      "applySelectedLines": "Wert übernehmen | {count} Werte übernehmen",
      "headlineExistingInvoices": "Bestehende Nebenkostenabrechnungen",
      "headlineUNewUtilitybill": "Neue Nebenkostenabrechnung",
      "headlineUtilitybill": "Nebenkostenabrechnung",
      "headlineUtilitybills": "Abrechnungsdokument|Abrechnungsdokumente",
      "importFromLatestLines": "Werte aus der letzten Abrechnung importieren",
      "latestUtilitybillExampleValues": "Zum Vergleich sind die Werte der letzten Abrechnung eingeblendet oder vorausgefüllt",
      "otherUtilitybillExampleValues": "Zum Vergleich werden die Werte der ausgewählten Abrechnung \"{name}\" verwendet",
      "selectImportSource": "als Vorlage",
      "title": "Nebenkostenabrechnungen"
    },
    "operatingcostinvoicesDetail": {
      "title": "Nebenkostenabrechnung"
    },
    "operatingcostinvoicesDetailEdit": {
      "title": "Nebenkostenabrechnung bearbeiten"
    },
    "operatingcostinvoicesNew": {
      "title": "Neue Nebenkostenabrechnung"
    },
    "partnerCompanies": {
      "title": "Partnerunternehmen"
    },
    "partnergroups": {
      "title": "Partnergruppen"
    },
    "partnergroupsDetail": {
      "title": "Partnergruppendetails"
    },
    "partnergroupsDetailEdit": {
      "title": "Partnergruppe bearbeiten"
    },
    "partnergroupsNew": {
      "title": "Neue Partnergruppe"
    },
    "partners": {
      "title": "Partner"
    },
    "partnersDetail": {
      "title": "Partnerdetails"
    },
    "partnersDetailEdit": {
      "title": "Partner bearbeiten"
    },
    "partnersNew": {
      "title": "Neuer Partner"
    },
    "partnerTypes": {
      "title": "Partnerarten"
    },
    "payments": {
      "title": "Zahlungen"
    },
    "pointOfSales": {
      "title": "Point of Sale (POS)"
    },
    "pointofsales": {
      "title": "Verkaufspunkte"
    },
    "pointofsalesDetail": {
      "title": "Verkaufspunkt Details"
    },
    "pointofsalesDetailEdit": {
      "title": "Verkaufspunkt bearbeiten"
    },
    "pointofsalesNew": {
      "title": "Neuer Verkaufspunkt"
    },
    "processes": {
      "endOfProcess": "Ende des Prozesses",
      "external": "Externer Prozess: {procname}",
      "processAssignedTeam": "Zugewiesenes Team: {team}",
      "processJSON": "Prozess-JSON",
      "tabs": {
        "isDraft": "Arbeitsstand",
        "isDraft:false": "Produktiv",
        "isDraft:true": "Entwurf"
      },
      "taskClosed": "Aufgabe abgeschlossen",
      "title": "Prozessmodellierung",
      "triggersSectionHeadline": "Ausgelöste Trigger",
      "uiPluginSectionHeadline": "Aktionskomponenten"
    },
    "processesDetail": {
      "title": "Einzelprozess"
    },
    "processesEdit": {
      "title": "Prozess bearbeiten"
    },
    "processesNew": {
      "title": "Neuer Prozess"
    },
    "products": {
      "title": "Produkte"
    },
    "rating": {
      "title": "Bewertung"
    },
    "recurringPayment": {
      "title": "Wiederkehrende Zahlungen"
    },
    "recurringPaymentTypes": {
      "title": "Typen wiederkehrender Zahlungen"
    },
    "resultCategories": {
      "title": "Ergebnis-Kategorien"
    },
    "salutions": {
      "title": "Anrede"
    },
    "savingTypes": {
      "title": "Ersparnisarten"
    },
    "servicecontracts": {
      "headlineExistingContracts": "Bestehende Serviceverträge",
      "headlineNewContract": "Neuer Servicevertrag",
      "title": "Serviceverträge"
    },
    "servicecontractsDetailServiceconditionsDetailEdit": {
      "title": "Vertragsbedingung bearbeiten"
    },
    "servicecontractsDetailServiceconditionsNew": {
      "title": "Neue Vertragsbedingung"
    },
    "servicecontractsDetailServicecontactDetailEdit": {
      "title": "Kontakt bearbeiten"
    },
    "servicecontractsDetailServicecontactNew": {
      "title": "Neuer Kontakt"
    },
    "servicecontractsDetailServicecontractactionsDetailEdit": {
      "title": "Vertragsaktion bearbeiten"
    },
    "servicecontractsDetailServicecontractactionsNew": {
      "title": "Neue Vertragsaktion"
    },
    "servicecontractsDetailServicepaymentEdit": {
      "title": "Zahlung bearbeiten"
    },
    "servicecontractsDetailServicepaymentNew": {
      "title": "Neue Zahlung"
    },
    "serviceobjects": {
      "title": "Serviceobjekte"
    },
    "serviceobjectsDetail": {
      "title": "Serviceobjekt"
    },
    "serviceobjectsDetailServiceobjectmaintenancestatusDetail": {
      "title": "Serviceobjekt-Wartungsstatus"
    },
    "serviceobjectsDetailServiceobjectmaintenancestatusNew": {
      "title": "Neuer Serviceobjekt-Wartungsstatus"
    },
    "serviceobjectsDetailServiceobjectpartnersDetail": {
      "title": "Serviceobjektpartner"
    },
    "serviceobjectsDetailServiceobjectpartnersNew": {
      "title": "Neuer Serviceobjektpartner"
    },
    "serviceobjectsNew": {
      "title": "Neues Serviceobjekt"
    },
    "sfmpositions": {
      "title": "SFM - Positionen"
    },
    "tableGroups": {
      "title": "Tabellengruppen"
    },
    "tables": {
      "title": "Tabellen"
    },
    "tags": {
      "title": "Tags"
    },
    "tapsInvoicePositions": {
      "title": "Taps Rechnungspositionen"
    },
    "taxinvoices": {
      "title": "TA Rechnungen"
    },
    "teams": {
      "title": "Teams"
    },
    "teamsDetail": {
      "title": "Teamdetails"
    },
    "teamsDetailEdit": {
      "title": "Team bearbeiten"
    },
    "teamsNew": {
      "title": "Neues Team"
    },
    "textModules": {
      "title": "Textmodule"
    },
    "textTemplates": {
      "title": "Textvorlagen"
    },
    "textTemplateVariables": {
      "title": "Textvorlagenvariablen"
    },
    "ticketListIssue": {
      "title": "Ticket Liste Problem"
    },
    "ticketPriorities": {
      "title": "Ticket-Prioritäten"
    },
    "tickets": {
      "noOpenTasks": "Keine offenen Aufgaben",
      "notificationNextStepMaintext": "Nächster Schritt \"{stepName}\"",
      "notificationNextStepSubtext": "{stepDescription}",
      "notificationSwitchProcessNextStepMaintext": "Wechsel zum Prozess \"{name}\"",
      "notificationSwitchProcessNextStepSubtext": "{description}",
      "tabs": {
        "all": "Alle",
        "status": "Status",
        "status:inProgress": "In Arbeit",
        "status:openOrNew": "Offen",
        "status:overdue": "Überfällig",
        "teams": "Team"
      },
      "title": "Tickets",
      "uiplugin": "Aktionskomponente: {name}",
      "uipluginBlockedMain": "Dieser Schritt ist noch nicht abgeschlossen",
      "uipluginBlockedSub": "Beenden Sie die die noch offenen Aufgaben",
      "uipluginOpenExternal": "Auf Seite bearbeiten",
      "uipluginOpenInModal": "In Modal öffnen",
      "uiPlugins": {
        "blueprint": {
          "firstCondition": "Erste Bedingung",
          "secondCondition": "Zweite Bedingung"
        },
        "email": {
          "senderEmails": "Eingegangene Emails"
        }
      }
    },
    "ticketsDetail": {
      "headline": "Ticket #{ticketid}",
      "subheadline": "SUB",
      "ticketName": "[{ticketid}] {customerName}{documentType}{entryDate}",
      "title": "Ticket",
      "unnamed": "Aufgabe"
    },
    "ticketTypes": {
      "title": "Ticketarten (Kommen bald)"
    },
    "trackRecord": {
      "title": "Track Record"
    },
    "translations": {
      "title": "Übersetzungen"
    },
    "undefined": {
      "title": "Unbekannte Seite"
    },
    "units": {
      "title": "Einheiten"
    },
    "unknownPage": {
      "title": "Unbekannnte Seite"
    },
    "usageTypes": {
      "title": "Verwendungstypen"
    },
    "users": {
      "title": "Benutzer"
    },
    "userTypes": {
      "title": "Benutzertypen"
    }
  },
  "placeholder": {
    "brevoTemplate": "Vorlage auswählen",
    "columns": "Sichtbare Spalten",
    "comment": "Neuer Kommentar",
    "enterLinkName": "Text der Auswahl",
    "enterStepname": "Schrittname",
    "name": "Name",
    "note": "Neue Notiz",
    "noTeamAssigned": "Kein Team zugewiesen",
    "quickfilter": "Schnellfilter",
    "selectContract": "Vertrag auswählen",
    "selectCustomer": "Kunde auswählen",
    "selectCustomerGroup": "Kundengruppe auswählen",
    "selectExistingAddress": "Wählen Sie eine bestehende Adresse",
    "selectExistingContactPerson": "Vorhandene Kontaktperson auswählen",
    "selectOrCreateStep": "Wählen Sie einen Schritt aus oder erstellen Sie einen neuen",
    "selectPointOfSale": "Verkaufsstelle auswählen",
    "uiPluginParamInputPlaceholder": "Optionstext einfügen"
  },
  "primevue": {
    "clear": "Löschen",
    "dayNames": [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    "dayNamesMin": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "dayNamesShort": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "firstDayOfWeek": 1,
    "monthNames": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    "today": "Heute"
  },
  "text": {
    "addMultipleObjectionItems": "Mehrere Widerspruchseinträge hinzufügen",
    "attachmentToolbarHeader": "Anhang \"{attachment}\" aus Email \"{email}\"",
    "changeStepVisibilities": "Sichtbarkeit der Schritte ändern",
    "contractsFilterActive": "Filter aktiv: Nur Verträge für diesen POS",
    "costOverview": "Kostenübersicht",
    "customerData": "Kundendaten",
    "deadlines": "Fristen",
    "deadlinesAndPayments": "Fristen & Zahlungen",
    "detailToolbarHeader": "Detailansicht von {name}",
    "detailToolbarHeaderDefault": "Detailansicht",
    "document": "Dokument",
    "documents": "Dokumente",
    "emails": "E-Mails",
    "emailToolbarHeader": "Email \"{email}\" von {name}",
    "invoiceDetails": "Rechnungsdetails",
    "invoiceLineItem": "Teilabrechnungsposition",
    "invoiceLineItems": "Teilabrechnungspositionen",
    "maintenanceStatus": "Wartungsstatus",
    "masterData": "Stammdaten",
    "noInvoicesFound": "Keine Rechnungen gefunden",
    "objectionPosition": "Widerspruchsposition",
    "objectionPositionRelatedItem": "Widerspruchspositionsbezogener Eintrag",
    "objectionPositions": "Widerspruchspositionen",
    "optionalPlugin": "Dieser Schritt ist optional",
    "posUsage": "Verwendung der Verkaufsstelle",
    "relatedData": "Verknüpfte Daten",
    "selectDocumentToSign": {
      "headline": "Zum Signieren verfügbare Dokumente",
      "text": "Wählen Sie ein Dokument aus, welches Sie über YouSign den Unterzeichnern zum Signieren senden möchten."
    },
    "selectedItems": "Ausgewählte Einträge",
    "signers": {
      "dosubmit": "Benachrichtige die Unterzeichner, dass ein Dokument zur Signatur bereitsteht.",
      "headline": "Unterzeichner für \"{document}\"",
      "requestNotStarted": "Signaturanfrage wurde noch nicht gestartet.",
      "requestStarted": "Signaturanfrage wurde gestartet. Das Dokument \"{document}\" wurde den Vertragsparteien zur Unterschrift vorgelegt und diese werden per Email benachrichtigt.",
      "text": "Füge Unterzeichner zu diesem Dokument hinzu."
    },
    "signingOngoing": {
      "headline": "Signaturstatus für \"{document}\"",
      "text": "Der Signaturprozess für dieses Dokument läuft derzeit."
    },
    "tapOverview": "TAP-Überblicks",
    "trackRecords": "Änderungshistorie",
    "trackRecordsTicket": "Tickethistorie"
  },
  "titletags": {
    "addLang": "Füge Übersetzung für „{locale}“ hinzu",
    "back2list": "Zurück zur Liste",
    "back2origin": "Zurück zur vorherigen Seite",
    "booleanFalse": "Nein",
    "booleanTrue": "Ja",
    "change": "Ändern",
    "chooseFile": "Datei auswählen",
    "chooseFiles": "Dateien auswählen",
    "classificationStatusFalse": "Unklassifiziert",
    "classificationStatusTrue": "Klassifiziert",
    "collapse": "Text minimieren",
    "comments": "Ein|{count} Kommentar|Kommentare",
    "costInvoiceActual": "Kostenposten",
    "costInvoiceDraft": "Entwurf aus Vorjahresposten",
    "expand": "Gesamten Text anzeigen",
    "isDraftFalse": "Ist produktiv",
    "isDraftTrue": "Ist ein Entwurf",
    "notes": "Persönliche Notiz|Notizen (lokal gespeichert)",
    "pan": "Ziehen zum Verschieben (Alt oder rechte Maustaste",
    "processAssigned": "Zugewiesener Prozess: \"{process}\"",
    "processName": "Unter diesem Label erscheint die Auswahl im Ticket",
    "processRemoveOption": "Option entfernen",
    "processRemovePlugin": "Plugin entfernen",
    "processRemoveTrigger": "Trigger entfernen",
    "processStepAssigned": "Prozessschritt: \"{step}\"",
    "reorderableRows": "Eigene Sortierung vornehmen",
    "reorderableRowsEnabled": "Sortierung beenden",
    "reset": "Zurücksetzen",
    "save": "Speichern",
    "showDashboardSettings": "Einstellungen für Dashboard",
    "showPreferenceSettings": "Einstellungen für Ticketdarstellung",
    "showTableSettings": "Tabellenkonfiguration",
    "stampedFalse": "Nicht gestempelt",
    "stampedTrue": "Gestempelt",
    "tasks": "Eine Aufgabe muss gelöst werden, um das Ticket weiter zu bewegen.|{count} Aufgaben müssen gelöst werden, um das Ticket weiter zu bewegen.",
    "teamAssigned": "Zugewiesenes Team: \"{team}\"",
    "ticketEntryDate": "Eingangsdatum des Tickets",
    "ticketProcessDeadlinedAt": "Zieldatum, um dieses Ticket abzuschließen: {date}",
    "ticketStatus": "Aktueller Ticketstatus: \"{status}\"",
    "ticketStepDeadlinedAt": "Bis {date} sollte dieser Schritt erledigt sein",
    "toggleRefresh": "Aktualisieren",
    "toggleSplitviewOff": "Geteilte Ansicht",
    "toggleSplitviewOn": "Vollansicht",
    "toggleToEditViewModeOnDblClick": "Zum Ansichtsmodus zurück mit Doppelklick",
    "toggleToEditVodeOnDblClick": "Bearbeiten mit Doppelklick"
  },
  "toast": {
    "create": {
      "detail": "Eintrag wurde erstellt"
    },
    "default": {
      "detail": "Anfrage wurde ausgeführt",
      "summary": "Erledigt"
    },
    "delete": {
      "detail": "Eintrag wurde gelöscht"
    },
    "error": "Fehler",
    "error403": "Verboten",
    "errors": {
      "brokenJSON": "JSON-Format kaputt",
      "CANNOT_BE_CREATED": "Element kann nicht erstellt werden",
      "CANNOT_BE_DELETED": "Element kann nicht gelöscht werden",
      "CANNOT_BE_FOUND": "Element kann nicht gefunden werden",
      "CANNOT_BE_UPDATED": "Element kann nicht aktualisiert werden",
      "Constraint violation exception": "Datei bereits vorhanden",
      "DOCUMENT_FIRST_REVIEWER_MISSING": "Erstprüfer fehlt! Die Stempelung ist nicht korrekt.",
      "encrypted": "Datei ist verschlüsselt und kann nicht hochgeladen werden",
      "FILE_DOWNLOAD_ERROR": "Fehler beim Laden des Dokuments.",
      "FILE_NOT_FOUND": "Dokument wurde nicht gefunden (404).",
      "Internal server error": "Auf Serverseite ist ein Fehler aufgetreten",
      "noEmailOnPOS": "Keine Email am POS hinterlegt"
    },
    "load": {
      "detail": "Datenliste neu geladen"
    },
    "position": {
      "detail": "Reihenfolge global für alle Nutzer geändert",
      "summary": "Neu sortiert"
    },
    "send": {
      "detail": "E-Mail wurde gesendet"
    },
    "trigger": {
      "detail": "wurde ausgelöst.",
      "summary": "Trigger \"{id}\""
    },
    "update": {
      "detail": "Eintrag wurde aktualisiert",
      "multi": {
        "detail": "{count} Einträge wurden aktualisiert",
        "summary": "Mehrere Einträge aktualisiert"
      }
    }
  }
}
